/**
 * use-operators — producer/operator catalog for the New Job form (Quick 260614-t4m / #5).
 *
 * Sources GET /v1/operators (dispatcher-readable, CREATE_JOB-gated). Changes
 * rarely → long staleTime, no poll.
 */

import { useApiQuery, useApiOpts } from '@lodex-pro/web-shared';

/** A single operator/producer row from GET /v1/operators. */
export interface Operator {
  readonly id: string;
  readonly name: string;
}

/** Response envelope for GET /v1/operators. */
export interface OperatorsResponse {
  readonly operators: readonly Operator[];
}

/** Stable array query key (RESEARCH Pitfall 4). */
export const OPERATORS_QUERY_KEY = ['operators', 'catalog'] as const;

/** Fetch the operator catalog. staleTime 5 min. */
export function useOperators(
  apiOpts: ReturnType<typeof useApiOpts>,
): ReturnType<typeof useApiQuery<OperatorsResponse>> {
  return useApiQuery<OperatorsResponse>(apiOpts, '/v1/operators', {
    queryKey: OPERATORS_QUERY_KEY,
    staleTime: 300_000,
  });
}
